import type {InteractiveActivityBlock} from './interactive-activity';

export function allowsAnswerAttachments(block:InteractiveActivityBlock):boolean {
 if(block.allowAttachments!==undefined)return block.allowAttachments;
 return block.type==='question'&&!block.resourceMeasurementTable&&['open','formula'].includes(block.answerType);
}

const tp5PhotoAttachmentBlockIds = new Set([
 "q3","q4","q5","q6","tableau-a","choix-xmax","q9","volumes-a",
 "q10","tableau-b","b-prevision","b-observation","q11","bilan",
]);

export function allowsAnswerAttachmentsForActivity(activityId:string, block:InteractiveActivityBlock):boolean {
 if(activityId==="reference-tp5-avancement" && tp5PhotoAttachmentBlockIds.has(block.id)) return true;
 return allowsAnswerAttachments(block);
}

export type ManipulationReport={items:{label:string;detail:string;state:'green'|'orange'|'red'}[];result:Record<string,number|boolean|string>};
export function manipulationReport(input:unknown):ManipulationReport|null {
 if(!input||typeof input!=='object')return null;
 const p=input as Record<string,unknown>;
 if(!Array.isArray(p.items)||!p.items.length||p.items.length>100||!p.result||typeof p.result!=='object'||Array.isArray(p.result))return null;
 if(!p.items.every(i=>i&&typeof i.label==='string'&&i.label.length<500&&typeof i.detail==='string'&&i.detail.length<2000&&['green','orange','red'].includes(i.state)))return null;
 return {items:p.items.map(i=>({label:i.label,detail:i.detail,state:i.state})),result:Object.fromEntries(Object.entries(p.result).filter(([,v])=>typeof v==='boolean'||typeof v==='number'&&Number.isFinite(v)||typeof v==='string'&&v.length<500))};
}
export function savedManipulation(value:string):ManipulationReport|null {
 try{const p=JSON.parse(value);return p.format==='validated-manipulation-v1'?manipulationReport(p.report):null;}catch{return null;}
}
